




































import { computed, defineComponent, onMounted, onUnmounted, PropType, ref, toRef, watch } from "@vue/composition-api";
import Cropper from "cropperjs";
import { TranslateResult } from "vue-i18n";
import "cropperjs/dist/cropper.css";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import { DragMode, ViewMode } from "./types";

export default defineComponent({
  name: "ImageCropper",
  components: { BaseIcon, BaseButton },
  props: {
    src: { type: String, required: true },
    previewSize: { type: Number, default: 56 },
    previewTitle: { type: String as PropType<TranslateResult | string>, default: "" },
    previewSubtitle: { type: String as PropType<TranslateResult | string>, default: "" },
    loading: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const image = ref();
    const minZoomValue = ref(0.1);
    const MAX_ZOOM_VALUE = 3;
    const ZOOM_STEP = 0.01;
    const CROP_ZONE_SIZE = 327;
    const zoomValue = ref(1);
    const progressWidth = computed(
      () => ((zoomValue.value - minZoomValue.value) / (MAX_ZOOM_VALUE - minZoomValue.value)) * 100 + "%"
    );
    let cropper: Cropper;

    const onZoomEvent = (evt: CustomEvent) => {
      zoomValue.value = evt.detail.ratio;
    };
    const viewMode: ViewMode = 1;
    const dragMode: DragMode = "move";
    const cropperOptions = {
      aspectRatio: 1,
      viewMode: viewMode,
      dragMode: dragMode,
      minCropBoxHeight: CROP_ZONE_SIZE,
      minCropBoxWidth: CROP_ZONE_SIZE,
      cropBoxMovable: false,
      cropBoxResizable: false,
      background: false,
      guides: false,
      center: false,
      modal: true,
      scalable: false,
      preview: ".image-cropper__preview",
      zoom: (evt: CustomEvent) => onZoomEvent(evt),
      ready: () => {
        const imageData = cropper.getImageData();
        const imageSizeCropZoneRatio = CROP_ZONE_SIZE / Math.min(imageData.naturalWidth, imageData.naturalHeight);
        minZoomValue.value = +imageSizeCropZoneRatio.toFixed(2);
        cropper.zoom(0.01);
      },
    };

    const onZoomInput = (evt: Event) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      zoomValue.value = Number(evt.target?.value);
      cropper.zoomTo(zoomValue.value);
    };

    const handleCropImage = () => {
      cropper
        .getCroppedCanvas({
          width: 327,
          height: 327,
        })
        .toBlob(blob => {
          emit("imageCropped", blob);
        }, "image/jpeg");
    };

    watch(toRef(props, "src"), () => cropper.replace(props.src), {
      flush: "post",
    });

    onMounted(() => {
      cropper = new Cropper(image.value, cropperOptions);
    });

    onUnmounted(() => {
      cropper.destroy();
    });
    return {
      image,
      progressWidth,
      minZoomValue,
      MAX_ZOOM_VALUE,
      ZOOM_STEP,
      zoomValue,
      handleCropImage,
      onZoomInput,
    };
  },
});
